import React from 'react';
import Appointment_Approval from './Appointment_Approval';
import '../../CommonCSS/SocietyCSS.css'


const Appointment_ApprovalApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Student Leave Application</h5>
          </div>  
        </div>
        <Appointment_Approval/>
      </div>
    </div >
  );
};

export default Appointment_ApprovalApp;